import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const InfoContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.secondary};
`;
